import FullInfoField from 'components/FullInfoField/FullInfoField';
import React, { useContext } from 'react';
import moment from 'moment';
import { WatchFullInfoContext, IWatchFullInfoContext } from '../../../watchFullInfoState/watchFullInfoContext';

export const UpdatedField: React.FC = () => {
	const { watchFullInfo } = useContext<IWatchFullInfoContext>(WatchFullInfoContext);

	const inputValue = watchFullInfo?.updatedDate
		? `${moment(watchFullInfo.updatedDate).format('MM/DD/YYYY h:mm:ss A')} ${watchFullInfo.updatedBy}`
		: '-';

	return <FullInfoField label="lastUpdateLabel" value={inputValue} />;
};
